module.exports = __webpack_public_path__ + "img/board_edit-ar.f15feb3f.png";